// extracted by mini-css-extract-plugin
export var iFrameWrapper = "music-module--iFrameWrapper--6c3f0";
export var inner = "music-module--inner--8dd5a";
export var music = "music-module--music--16093";